import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { User } from '../classes/user.class';
import { CodaltComponent } from '../codalt.component';

export interface SelectExecutorDialogData {
    title: string;
    message: string;
    confirmButtonText?: string;
    availableExecutors: User[];
    sourceExecutor: User;
}

export interface SelectExecutorDialogResult {
    selectedExecutor: User;
}

@Component({
    selector: 'app-select-executor-dialog',
    templateUrl: './select-executor-dialog.component.html',
    styleUrl: './select-executor-dialog.component.scss',
    standalone: false,
})
export class SelectExecutorDialogComponent extends CodaltComponent implements OnInit {
    searchControl = new FormControl('');
    filteredExecutors: User[] = [];
    selectedExecutor: User | null = null;

    constructor(
        private dialogRef: MatDialogRef<SelectExecutorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SelectExecutorDialogData
    ) {
        super();
        this.filteredExecutors = [...this.data.availableExecutors];
    }

    ngOnInit(): void {
        this.setupSearch();
    }

    private setupSearch(): void {
        this.subscriptions.add(
            this.searchControl.valueChanges
                .pipe(startWith(''), debounceTime(300), distinctUntilChanged())
                .subscribe(searchTerm => {
                    this.filterExecutors(searchTerm || '');
                })
        );
    }

    private filterExecutors(searchTerm: string): void {
        if (!searchTerm.trim()) {
            this.filteredExecutors = [...this.data.availableExecutors];
            return;
        }

        const term = searchTerm.toLowerCase();
        this.filteredExecutors = this.data.availableExecutors.filter(
            executor =>
                executor.name.toLowerCase().includes(term) ||
                executor.firstname?.toLowerCase().includes(term) ||
                executor.lastname?.toLowerCase().includes(term)
        );
    }

    onExecutorSelect(executor: User): void {
        this.selectedExecutor = executor;
    }

    onConfirm(): void {
        if (this.selectedExecutor) {
            const result: SelectExecutorDialogResult = {
                selectedExecutor: this.selectedExecutor,
            };
            this.dialogRef.close(result);
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    trackByExecutorId(index: number, executor: User): number {
        return executor.id;
    }

    isExecutorSelected(executor: User): boolean {
        return this.selectedExecutor?.id === executor.id;
    }
}
